import { render } from "./BoundingBoxSizeFilter.vue?vue&type=template&id=7fcd064b&scoped=true"
import script from "./BoundingBoxSizeFilter.vue?vue&type=script&lang=js"
export * from "./BoundingBoxSizeFilter.vue?vue&type=script&lang=js"

import "./BoundingBoxSizeFilter.vue?vue&type=style&index=0&id=7fcd064b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fcd064b"]])

export default __exports__